/*
  Simple text — optional "Read More" collapse.

  The full content is always rendered into the page; this only hides the tail
  visually once the text runs past the character limit set on the block. That
  keeps every word in the HTML source for crawlers, and leaves the content
  fully readable if this script never runs.

  Operates directly on .text-wpr rather than adding a wrapper element, because
  the theme styles .WYSIWYG-styles > * (and :first-child / :last-child), so an
  extra div would absorb those margin rules instead of the paragraphs.
*/
(function () {
  'use strict';

  var SELECTOR = '[data-read-more]';
  /* Children that are chrome, not prose, and must not be counted or hidden. */
  var SKIP = '.simple-text-title, .button-wpr, .simple-text-rm__toggle';
  var HIDDEN = 'simple-text-rm__hidden';

  function contentChildren(el) {
    return Array.prototype.filter.call(el.children, function (kid) {
      return !kid.matches(SKIP);
    });
  }

  /* A word is any run of non-whitespace, so "IFP-131™" counts once. */
  function countWords(str) {
    var words = str.match(/\S+/g);
    return words ? words.length : 0;
  }

  /* Trailing punctuation that should be tucked into the hidden tail before an
     ellipsis, so it reads "follicle…" rather than "follicle,…". */
  var TRAILING = /[\s,;:–—-]/;

  /* A cut that already lands on a finished sentence needs no ellipsis. */
  var SENTENCE_END = /[.!?][)"'”’]*$/;

  function wrapHidden(node) {
    var span = document.createElement('span');
    span.className = HIDDEN;
    node.parentNode.insertBefore(span, node);
    span.appendChild(node);
    return span;
  }

  function appendEllipsis(el) {
    var span = document.createElement('span');
    span.className = 'simple-text-rm__ellipsis';
    span.textContent = '…';
    el.appendChild(span);
  }

  /* Hide everything past `remaining` words inside a single block element.
     Declines when there is no budget left, which is what happens when the
     limit lands exactly on a block boundary — keeping one more word there
     would overshoot the limit by a word. */
  function clampWithin(el, remaining) {
    if (remaining < 1) return false;

    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
    var count = 0;
    var cutNode = null;
    var cutOffset = 0;
    var rest = [];
    var node;

    while ((node = walker.nextNode())) {
      if (cutNode) {
        rest.push(node);
        continue;
      }

      var text = node.nodeValue;
      var re = /\S+/g;
      var match;
      while ((match = re.exec(text))) {
        count++;
        if (count >= remaining) {
          cutNode = node;
          /* Cut immediately after the last word we are keeping. */
          cutOffset = match.index + match[0].length;
          break;
        }
      }
    }

    if (!cutNode) return false;

    var visible = cutNode.nodeValue.slice(0, cutOffset);
    var finishesSentence = SENTENCE_END.test(visible);

    /* Move the cut back over trailing punctuation rather than deleting it, so
       the hidden tail still restores the original copy on expand. */
    if (!finishesSentence) {
      var trimmed = cutOffset;
      while (trimmed > 0 && TRAILING.test(cutNode.nodeValue.charAt(trimmed - 1))) {
        trimmed--;
      }
      if (trimmed > 0) cutOffset = trimmed;
    }

    var tailSpan = wrapHidden(cutNode.splitText(cutOffset));

    if (!finishesSentence) {
      var ellipsis = document.createElement('span');
      ellipsis.className = 'simple-text-rm__ellipsis';
      ellipsis.textContent = '…';
      tailSpan.parentNode.insertBefore(ellipsis, tailSpan);
    }

    rest.forEach(function (n) {
      if (n.parentNode) wrapHidden(n);
    });

    return true;
  }

  function clamp(el, limit) {
    var kids = contentChildren(el);
    if (!kids.length) return false;

    var count = 0;
    var cut = false;
    var lastVisible = null;

    for (var i = 0; i < kids.length; i++) {
      if (cut) {
        kids[i].classList.add(HIDDEN);
        continue;
      }

      var words = countWords(kids[i].textContent);
      if (count + words <= limit) {
        count += words;
        lastVisible = kids[i];
        continue;
      }

      cut = clampWithin(kids[i], limit - count);
      if (!cut) {
        kids[i].classList.add(HIDDEN);
        cut = true;
        /* This block is hidden whole, so any ellipsis belongs on the end of
           the last one still showing — unless it already ends a sentence. */
        if (lastVisible && !SENTENCE_END.test(lastVisible.textContent.replace(/\s+$/, ''))) {
          appendEllipsis(lastVisible);
        }
      }
    }

    return cut;
  }

  function init(scope) {
    var els = (scope || document).querySelectorAll(SELECTOR);

    Array.prototype.forEach.call(els, function (el) {
      if (el.dataset.readMoreReady === '1') return;
      el.dataset.readMoreReady = '1';

      /* Free-form number input, so it can arrive blank, zero or negative. */
      var limit = parseInt(el.getAttribute('data-read-more-words'), 10);
      if (!isFinite(limit) || limit < 1) limit = 50;

      var total = contentChildren(el).reduce(function (sum, kid) {
        return sum + countWords(kid.textContent);
      }, 0);
      if (total <= limit) return;

      if (!clamp(el, limit)) return;

      var more = el.getAttribute('data-read-more-label') || 'Read More';
      var less = el.getAttribute('data-read-less-label') || 'Read Less';

      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'simple-text-rm__toggle';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = more;

      toggle.addEventListener('click', function () {
        var expanded = el.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        toggle.textContent = expanded ? less : more;
      });

      el.classList.add('is-clamped');

      /* Sit above the block's CTA button when it has one. */
      var cta = el.querySelector(':scope > .button-wpr');
      if (cta) {
        el.insertBefore(toggle, cta);
      } else {
        el.appendChild(toggle);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  /* Theme editor re-renders the section on every setting change. */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  /* Open the block the merchant is editing so they can see the full copy. */
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target.matches(SELECTOR) ? e.target : e.target.querySelector(SELECTOR);
    if (!el || !el.classList.contains('is-clamped')) return;
    if (el.classList.contains('is-expanded')) return;
    var btn = el.querySelector('.simple-text-rm__toggle');
    if (btn) btn.click();
  });
})();
